<template>

    <section class="container-fluid">
        <div class="row mcas">
            <div class="col-md-6 col-lg-4 main lr" id="mlrp">
                <div class="row nav-top">
                    <div class="col-8 ddavc"><span class="nav-back wt" id="back" @click="$router.go(-1)"></span><span
                            class="tfw-5 tf-18" id="navNam">Register</span></div>
                </div>
                <div class="row">
                    <div class="col-12 pt-4 xtc" id="cimg"><img src="../assets/logo.png" height="170"></div>
                    <div class="col-12" id="vrgj89b">
                        <div class="row">
                            <div class="col-12">
                                <div class="row mr-0 mt-2 pt-1">
                                    <div class="col-12 inpbcx"><span class="xicon cell"></span><span
                                            class="xicon tf-18">+91</span> <input type="tel" class="xbox" v-model="user.username" @input="check()" id="emob" maxlength="10" placeholder="Mobile Number"
                                            autocomplete="off" ></div>
                                    <div class="col-12 inpbcx"><span class="xicon lock"></span> <input class="xbox pin"
                                        v-model="user.password" @input="check()"
                                                id="epass" maxlength="21"
                                            placeholder="Login Password (≥6 characters)" autocomplete="off"
                                            ></div>
                                    <div class="col-12 inpbcx"><span class="xicon lock"></span> <input class="xbox pin"
                                        v-model="user.confirmpassword" @input="check()"
                                                id="econpass"
                                            placeholder="Confirm Login Password" autocomplete="off" >
                                    </div>
                                    <div class="col-12 inpbcx"><span class="xicon refcode"></span> <input class="xbox"
                                        v-model="user.refcode" @input="check()"
                                                id="ref" maxlength="21" placeholder="invite Code"
                                            autocomplete="off" ></div>
                                    <div class="col-12 inpbcx"><span class="xicon key"></span> <input type="tel"
                                            class="xbox" v-model="user.code" @input="check()"
                                                id="code" maxlength="6"
                                            placeholder="Verification Code" autocomplete="off" >
                                        <span class="GROTP" id="otpbtn" @click="otp()">OTP</span></div>
                                    <div class="col-12 pa-0 pt-1 mt-3 mb-2">
                                        <div class="btn-main" id="regis" @click="onRegister()">Register</div>
                                        <div class="btn-main act" style="display:none" id="load"><img class='spin'  src='../assets/includes/images/loader.png' style="height: 28px"></div>
                                    </div>
                                    <div class="col-12 pa-0 pt-1 mt-3 mb-2 tfcdb tf-16"><span class="mr-2">Already have
                                            an account?</span><span class="mcpl tcopink" onclick="window.location.href='#/login'">Log
                                            in</span></div>
                                    <div class="col-12 pa-0 pt-1 mb-2 tfcdb tf-16 gsbgi"><span><input type="checkbox"
                                                id="ccbox" checked=""></span><span class="mr-2">I agree</span><span
                                            class="mcpl tcopink" onclick="ppolicy()">PRIVACY POLICY</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" id="dta_ref">
                        <div class="col-12 conod LR" @click="clink" id="clink" style="display :none;">
                            <div class="ssmg fadein" >
                                <div class="tf-14" id="smgid">Password error, Please check</div>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
    </section>

</template>

<script>

import axios from "axios";
export default {
    name: "RegisterView",
    data() {
        return {
            countDown: 60,
            otpactive: true,
            register:false,
            user: {
                username: null,
                password: null,
                code: null,
                refcode: null,

            }
        }

    },
    beforeCreate: function () {
        if (localStorage.getItem('username') != null)
            this.$router.push({ name: 'mine' });
    },
    created: function () {
        this.user.refcode = this.$route.query.C;
    },

    methods: {
        pop(message) {
            document.getElementById("smgid").innerHTML = message;
            document.getElementById("clink").style.display = "";
            this.stopspin();
        },
        spin(){
            console.log("load");
            document.getElementById("regis").style.display = "none";
            document.getElementById("load").style.display = "";   
        },
        stopspin() {
            document.getElementById("regis").style.display = "";
            document.getElementById("load").style.display = "none";
            
        },
        clink(){
            document.getElementById("clink").style.display = "none";
        },
        check() {
            //console.log(document.getElementById("ccbox").checked);
            if (document.getElementById("emob").value.length == 10 && document.getElementById("epass").value.length > 5) {
                document.getElementById("regis").className = "btn-main act";
                this.register=true;
            } else {
                document.getElementById("regis").className = "btn-main";
                this.register=false;
            }
        },
        onRegister() {
            if (this.register==true) {
                
                this.spin();
                var data = new FormData();
                data.append("username", this.user.username);
                data.append("password", this.user.password);
                data.append("code", this.user.code);
                data.append("refcode", this.user.refcode);
                axios
                    .post(
                        "https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=register",
                        data
                    )
                    .then(res => {
                        if (res.data[0].status == "success") {
                            this.pop(res.data[0].status);
                            console.log("Success", res.data[0].status);
                            setTimeout(() => { this.$router.push("/login"); }, 600);
                        } else {
                        
                            console.log("Error", res.data);
                            this.pop(res.data[0].status);
                        }
                    })
                    .catch(err => {
                        console.log("Error", err);
                    });
            }
        },
        redirect() {
            console.log(this.$store.state.name);
            //this.$router.push({ name: 'Search' });
        },
        countDownTimer() {
            this.otpactive = false;
            document.getElementById("otpbtn").innerHTML = + this.countDown + "s";
            if (this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1
                    this.countDownTimer()
                }, 1000)
            } else {
                document.getElementById("otpbtn").innerHTML = "Resend code";
                this.otpactive = true;
            }
        },
        otp() {
            if (this.user.username != null) {
                if (this.otpactive == true) {
                    axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/otp.php?num=' + this.user.username);
                    this.countDownTimer();
                }

            } else {
                this.pop("Mobile number is requied")
            }

        },

      

    }




}
</script>